import produce from 'immer';

import {
  GROUP_CREATE_FAILURE,
  GROUP_FETCH_FAILURE,
  GROUP_FETCH_SUCCESS,
  GROUP_UPDATE_FAILURE,
  GROUPS_FETCH_SUCCESS,
} from '@actions/group';

const initialState: IGroupStore = {
  currentGroup: null,
  groups: null,
  error: null,
};

export default (state: IGroupStore = initialState, action: any) =>
  produce(state, (draftState: IGroupStore) => {
    switch (action.type) {
      case GROUP_FETCH_SUCCESS:
        draftState.currentGroup = action.response;
        draftState.error = null;

        return;

      case GROUP_CREATE_FAILURE:
      case GROUP_UPDATE_FAILURE:
      case GROUP_FETCH_FAILURE:
        draftState.error = action.error;

        return;
      case GROUPS_FETCH_SUCCESS:
        draftState.groups = action.response;
        draftState.error = null;

        return;
    }
  });
